import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PlanSVG from "@/components/PlanSVG";
import { AutoBIMLogo } from "@/components/Brand";

/**
 * PUBLIC read-only shared-plan viewer (no auth). Opened from the QR on the
 * "Plan Explanation" PDF so a client/contractor can explore the plan on a
 * phone: tap any element for its drawing + full explanation. Never editable.
 */
export default function SharedPlanView() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL;
    fetch(`${base}/api/editor/shared-plan/${token}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((data) => setState({ loading: false, error: null, data }))
      .catch((e) => setState({ loading: false, error: e.message || "error", data: null }));
  }, [token]);

  const ar = (state.data?.lang || "ar") === "ar";

  return (
    <div dir={ar ? "rtl" : "ltr"} style={{ minHeight: "100vh", background: "#0B0F14", color: "#E7ECF3" }}>
      <header style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 18px", borderBottom: "1px solid #1B2530" }}>
        <AutoBIMLogo size={30} />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 15, fontWeight: 900 }} data-testid="shared-plan-title">
            {state.data?.project_name || "AutoBIM Logic"}
          </div>
          <div style={{ fontSize: 11, color: "#8CA0B3" }}>
            {ar ? "معاينة تفاعلية - اضغط أي عنصر لعرض شرحه" : "Interactive preview - tap any element for its explanation"}
          </div>
        </div>
      </header>

      <main style={{ padding: 16, display: "grid", placeItems: "center" }}>
        {state.loading && (
          <div style={{ padding: 60, color: "#8CA0B3" }} data-testid="shared-plan-loading">
            {ar ? "جارٍ التحميل…" : "Loading…"}
          </div>
        )}
        {!state.loading && state.error && (
          <div style={{ padding: 60, textAlign: "center" }} data-testid="shared-plan-error">
            <p style={{ fontSize: 18, fontWeight: 800 }}>{ar ? "لم يُعثر على المخطط" : "Plan not found"}</p>
            <p style={{ color: "#8CA0B3", marginTop: 6 }}>
              {ar ? "قد يكون الرابط منتهيًا أو غير صحيح." : "The link may be expired or invalid."}
            </p>
          </div>
        )}
        {!state.loading && state.data?.model && (
          <div style={{ width: "100%", maxWidth: 1000, background: "#fff", borderRadius: 14, padding: 12 }}>
            <PlanSVG model={state.data.model} w={960} h={680} showScale showLegend showDims explain lang={ar ? "ar" : "en"} />
            <p style={{ marginTop: 8, fontSize: 12, fontWeight: 700, color: "#0891B2", textAlign: "center" }}>
              {ar ? "اضغط أي عنصر في المخطط لعرض رسمه وشرحه الكامل" : "Tap any element in the plan to see its drawing + full explanation"}
            </p>
          </div>
        )}
      </main>
    </div>
  );
}
